import { isToday } from '@/locales/dates';

const BillboardsWithAllEvents = [3510, 3512];
const BillboardsEventsMobileBackgroundPositionToLeft = [2409, 2411];
const BillboardsEventsMobileBackgroundPositionToRight = [2556, 1478];
const billboardsWithShortenTemplates = [
  3167, 1626, 3147, 1896, 3244, 3242, 3241, 3240, 3239, 3250, 3249, 3248, 3252,
  3312, 3212, 3323, 3324, 3322, 3319, 3320, 3321, 3436, 3445, 3461, 3477, 3529,
];
const EventsWithNewCommissions = [
  226166, 226167, 213545, 213570, 213571, 213572,
];

const eventsWithSaleLabel = [258897, 258899, 266469];

const eventsTemplateHybrid = [
  229071, 229313, 229314, 229315, 229316, 229317, 229117, 229318, 229319,
  229320, 229321, 229322, 240038, 240039, 240040, 240041, 240042, 240043,
  240044, 240045, 240046, 240047, 240048, 240049, 240050, 240051, 240052,
  240053, 240054, 240055, 240056, 240057, 240085, 240059, 240060, 240061,
  240062, 240063, 240064, 240065, 240066, 240067, 240068, 240069, 240070,
  240071, 240072, 240073, 240074, 240075, 240078, 240079, 240080, 240081,
  240082, 240083, 240084, 240085, 240086, 240087, 240088, 240089, 240090,
  240091, 240092, 240093, 240094, 240095, 240096, 240097, 240098, 240099,
  240100, 240101, 240102, 240103, 240104, 240105, 240106, 240107, 240108,
  240109, 240110, 240111, 240112, 240113, 240114, 240115, 240116, 240117,
  240118, 240119, 240120, 240121, 240122, 240123, 240124, 240125, 240130,
  240131, 240132, 240133, 240134, 240135, 240136, 240137, 240138, 240139,
  240140, 240141, 240142, 240143, 240144, 240145, 240343, 240342, 240341,
  240340, 240339, 240338, 240337, 240336, 240335, 240334, 240333, 240332,
  240331, 240330, 240329, 240328, 240327, 240326, 240325, 240324, 240323,
  240322, 240321, 240320, 240319, 240318, 240317, 240316, 240315, 240314,
  240313, 240312, 240311, 240310, 240309, 240308, 240307, 240306, 240305,
  240304, 240303, 240302, 240301, 240300, 240299, 240298, 240289, 240288,
  240287, 240286, 240285, 240284, 240283, 240282, 240297, 240296, 240295,
  240294, 240293, 240292, 240291, 240290, 240281, 240280, 240279, 240278,
  240277, 240276, 240275, 240274, 240273, 240272, 240271, 240270, 240269,
  240268, 240267, 240266, 240265, 240264, 240263, 240262, 240261, 240260,
  240259, 240258, 240257, 240256, 240255, 240254, 240253, 240252, 240251,
  240250, 240249, 240248, 240247, 240246, 240245, 240244, 240243, 240242,
  240241, 240240, 240239, 240238, 240237, 240236, 240235, 240234, 240233,
  240232, 240231, 240230, 240229, 240228, 240226, 240225, 240224, 240223,
  240227, 240204, 240222, 240221, 240220, 240219, 240218, 240217, 240216,
  240215, 240214, 240213, 240212, 240211, 240210, 240209, 240208, 240207,
  240206, 240205, 240643, 240644, 240645, 240646, 240647, 240648, 240649,
  240650, 240651, 240652, 240653, 240654, 240655, 240656, 240657, 240658,
  240659, 240660, 240661, 240662, 240663, 240664, 240665, 240666, 240667,
  240668, 240669, 240670, 240671, 240672, 240673, 240674, 240675, 240676,
  240677, 240678, 240679, 240680, 240681, 240682, 240683, 240684, 240685,
  240686, 240687, 240688, 240689, 240690, 240691, 240692, 240693, 240694,
  240695, 240696, 240697, 240698, 240699, 240700, 240701, 240702, 240703,
  240704, 240705, 240706, 240709, 240710, 240711, 240712, 240713, 240714,
  240715, 240716, 240717, 240718, 240719, 240720, 240721, 240722, 240723,
  240724, 240725, 240726, 240727, 240728, 240729, 240730, 240731, 240732,
  240733, 240734, 240735, 240736, 240737, 240738, 240739, 240740, 240741,
  240742, 240743, 240744, 240745, 240746, 240748, 240749, 240750, 240751,
  240752, 240753, 240754, 240755, 240756, 240757, 240758, 240759, 240760,
  240761, 240762, 240763, 240764, 240765, 240766, 240767, 240768, 240769,
  240770, 240771, 240772, 240773, 240774, 240775, 240776, 240777, 240778,
  240779, 240785, 240786, 240787, 240788, 240789, 240790, 240791, 240792,
  240793, 240794, 240795, 240796, 240797, 240798, 240799, 240800, 240801,
  240802, 240803, 240804, 240805, 240806, 240807, 240808, 240809, 240810,
  240811, 240812, 240813, 240814, 240815, 240816, 240818, 240819, 240820,
  240821, 240822, 240823, 240824, 240825, 240826, 240827, 240828, 240829,
  240830, 240831, 240832, 240833, 240834, 240835, 240836, 240837, 240838,
  240839, 240840, 240841, 240842, 240843, 240844, 240845, 240846, 240847,
  240848, 240849, 240850, 240851, 240852, 240853, 240854, 240855, 240857,
  240858, 240859, 240860, 240861, 240862, 240863, 240864, 240865, 240866,
  240867, 240868, 240869, 240870, 240871, 240872, 240873, 240874, 240875,
  240876, 240877, 240878, 240879, 240880, 240881, 240882, 240883, 240884,
  240885, 240886, 240887, 240888, 240889, 240890, 240891, 240892, 240893,
  240894, 240895, 240896, 240897, 240898, 240899, 240900, 240901, 240902,
  240903, 240904, 240905, 240906, 240907, 240908, 240909, 240910, 240911,
  240912, 240913, 240914, 240915, 240916, 240917, 240918, 240919, 240920,
  240937, 240946, 240954, 240963, 240964, 240965, 240966, 240967, 240968,
  240969, 240970, 240971, 240972, 240973, 240974, 240975, 240976, 240977,
  240978, 240979, 240980, 240981, 240982, 240983, 240984, 240985, 240986,
  240987, 240988, 240989, 240990, 240991, 240992, 240993, 240994, 240995,
  240996, 240997, 240998, 240999, 241000, 241002, 241003, 241004, 241005,
  241006, 241007, 241008, 241009, 241010, 241011, 241012, 241013, 241014,
  241015, 241016, 241017, 241018, 241019, 241020, 241021, 241022, 241023,
  241024, 241025, 241026, 241027, 241028, 241029, 241030, 241031, 241032,
  241033, 241034, 241035, 241036, 241037, 241038, 241039, 241040, 241041,
  241042, 241043, 241044, 241045, 241046, 241047, 241048, 241049, 241050,
  241051, 241052, 241053, 241054, 241055, 241056, 241057, 241058, 241059,
  241060, 241061, 241062, 241063, 241064, 241065, 241066, 241067, 241068,
  241069, 241070, 241071, 241072, 241073, 241074, 241075, 241076, 241077,
  241078, 241079, 241080, 241081, 241082, 241083, 241084, 241085, 241086,
  241087, 241088, 241089, 241090, 241091, 241092, 241093, 241094, 241095,
  241096, 241097, 241101, 241102, 241103, 241104, 241105, 241106, 241107,
  241108, 241109, 241110, 241111, 241112, 241113, 241114, 241115, 241116,
  241117, 241118, 241119, 241120, 241121, 241122, 241123, 241124, 241125,
  241126, 241127, 241128, 241129, 241130, 241131, 241132, 241133, 241134,
  241135, 241136, 241137, 241138,
];
const usersTemplateHybrid = [];

const eventsTemplateHiddenMap = [228539];
const usersTemplateHiddenMap = [];

const userToViewAvailability = [];
const eventToViewAvailability = [];

const eventsWithDarkMode = [213835];
const eventsRemoveNoCustomTicketButton = [213835];
const eventsRemoveApplyAllCustomTicketButton = [213835];

const BillboardDisabledHighlightedEvents = [
  2751, 2771, 2818, 2852, 3012, 3166, 3196, 3202, 3203, 3232, 3294, 3299, 3355,
  3364, 3434, 3474, 3482, 3495, 3503, 3510, 3512,
];
const BillboardRemoveEventsBanner = [3012];
const BillboardsEventsWithMXN = [238298, 238296, 238297];
const BillboardsCardDefaultAction = [2818];
const BillboardsRemoveTags = [1574, 2916];
const BillboardsRemoveOpenCard = [3203, 1638];

const BillboardOdysseySoldOut = [2751];
// const BillboardOdysseySoldOut = [2751];
const eventsSoldOut = [238296, 238297];
// const eventsSoldOut = [238296, 238297, 238298];

const fanPassword = {
  123: [
    {
      start_date: '2026-01-13T18:00:00Z',
      end_date: '2026-01-15T23:00:00Z',
      pass: 'MAGNATICOS',
    },
  ],
};

const promotionPreLoaded = {
  242478: 'NCMX15NAVIDAD',
  247186: 'GENERAL2X1',
  249585: 'ALEMAN2X1',
  249588: 'AMALIA2X1',
  249632: 'ALEMAN2X1',
  249633: 'ALEMAN2X1',
  249736: 'NTCBBVA25',
  252909: 'BBVA30',
  252905: '2X1',
  249323: '3X2POPTOUR',
  254313: 'MAYOO2X1',
  249323: '2X1POPTOUR',
  252595: 'TOLUCA11',
  251462: 'TWY2X1',
  258936: 'REGULAR2X1',
  252982: 'MUSICAMEXA',
  252980: 'MUSICAMEXA',
  252976: 'MUSICAMEXA',
  260200: '2X1',
  260204: '2X1',
  260205: '2X1',
  261186: 'BBVA',
  261425: 'FAMILIALDCR',
  261434: 'FAMILIALDCR',
  261124: 'TEST',
  258725: 'COMISARIO',
  260551: 'BBVA20',
  262287: 'FAMILIALDCR',
  262285: 'FAMILIALDCR',
  258792: 'HEROES',
  250028: 'MISSALEXA',
  262601: 'LDCR',
  254206: 'VICTORIA',
  262914: 'PRE31MIN',
  261884: 'FOREVER',
  259782: 'FLASHSALE',
  260466: 'LAHOLANDESA2X1',
  260579: '2X1',
  260661: 'GA2X1',
  264072: 'BANORTE10',
  258721: 'ARDEENMI',
  261677: '2X1TOL',
  263844: 'TEST2X1',
  261062: 'PROMO2X1',
  261680: '2X1PUE',
  264409: '2X1SHOW',
  262923: 'PROMO3X2',
  261681: 'VER2X1',
  261719: '3X2LM',
  261504: 'GOLDMAN',
  264689: 'RZ4X3',
  261758: '2X1',
  265439: 'BBVA',
  259733: 'SA3X2',
  265340: '30DESC',
  264001: 'FM2025',
  264565: 'PREFERENTE',
  266189: 'FIN2X1',
  266190: 'FIN2X1',
  266202: 'FIN2X1',
  266191: 'FIN2X1',
  266203: 'FIN2X1',
  266176: 'FIN4X3',
  266184: 'FIN4X3',
  265933: 'FAMILIA',
  265932: 'FAMILIA',
  266469: '40AMEX',
  261111: '2X1',
  263766: 'AMIGOSSAMMY',
  266181: '4X3',
  266182: '4X3',
  266183: '4X3',
  266186: '4X3',
  266187: '4X3',
  266192: '2X1',
  266193: '2X1',
  266194: '2X1',
  266195: '2X1',
  266196: '2X1',
  266197: '2X1',
  266198: '2X1',
  266199: '2X1',
  266200: '2X1',
  266204: '2X1',
  266205: '2X1',
  266206: '2X1',
  266207: '2X1',
  266208: '2X1',
  266209: '2X1',
  254672: 'MARTIN60',
  259301: 'MARTIN',
  254459: 'BLACKFRIDAY',
  254671: 'MARTIN50',
  258907: '2X1',
  258908: '30OFF',
  258905: '30OFF',
  258909: '30OFF',
  263820: 'ZV2X1',
  263159: 'BABAS2X1',
  261024: '30OFF',
  266636: 'PREVENTA20',
  265000: 'PREVENTA20',
  261525: 'BOLETIA2X1',
  265458: 'PAREJA',
  261462: 'BUENFIN',
  265050: 'BUENFIN15',
  266528: 'BUENFIN15',
  262462: '3X2TRONO',
  264763: 'DESP1',
  264761: 'DESP1',
  267150: 'PREVENTA',
  267170: 'PREVENTA',
  266043: 'BUENFIN',
  260166: 'BODA',
  266397: 'LOSCHOCLOKBF',
  266486: 'LOSCHOCLOKBF',
  266423: 'LOSCHOCLOKBF',
  266422: 'LOSCHOCLOKBF',
  266586: 'LOSCHOCLOKBF',
  264153: 'LAGARFIELDBLACKF',
  263922: 'LAGARFIELD2X1',
  263920: 'LAGARFIELD2X1',
  261759: 'FEST2X1',
  264149: 'BUENFIN',
  264864: 'BUENFIN',
  264410: 'CASIFEB',
  266630: 'BUENFIN',
  267183: 'BUENFIN4X3',
  267178: '20OFF',
  253430: 'BUENFIN2X1',
  267099: 'BUENFIN',
  266164: 'BUENFIN',
  265992: 'BUENFIN',
  266091: 'BUENFIN',
  266057: 'BUENFIN',
  266090: 'BUENFIN',
  266084: 'BUENFIN',
  244330: 'BUENFIN20',
  266641: 'PROMO2X1',
  266644: 'PROMO2X1',
  267078: 'BUENFIN',
  267121: 'BUENFIN',
  267122: 'BUENFIN',
  267123: 'BUENFIN',
  267124: 'BUENFIN',
  267125: 'BUENFIN',
  267126: 'BUENFIN',
  267127: 'BUENFIN',
  266256: 'BUENFIN',
  265999: 'BUENFIN30',
  253465: 'BUENFIN',
  266788: '40',
  262586: 'BUENFIN25',
  264895: 'BUENFIN25',
  262664: 'BUENFIN25',
  264762: 'BUENFIN25',
  264965: '4X3',
  267486: 'LOSCHOCLOKBF',
  266061: '50OFF',
  266374: 'RICHIEMETEPEC',
  267533: '3X2',
  267530: '3X2',
  259843: 'BUENFIN',
  253386: 'BUENFIN',
  259460: 'BUENFIN',
  258906: 'BUENFIN',
  262490: 'BOLETIA',
  262314: 'BOLETIA',
  263870: 'BOLETIA',
  263871: 'BOLETIA',
  266466: 'CUPON2X1',
  267143: 'ESPECIAL2X1',
  260656: 'BUENFIN',
  262751: 'BOLETIA',
  252499: 'JUEVES2X1',
  267098: '2X1',
  267092: '2X1',
  263119: 'BOLETIA',
  266431: 'INVITADO2X1',
  266432: 'INVITADO2X1',
  266453: '2X1',
  267817: '3X2',
  268111: 'TEO30',
  265956: '2X1',
  259870: '2X1',
  268173: '12ANIV',
  267435: '12ANIV',
  267436: '12ANIV',
  266398: '2X1',
  266341: '450',
  267336: '2X1',
  267338: '2X1',
  267342: '2X1',
  267344: '2X1',
  267348: '2X1',
  267350: '2X1',
  268260: '2X1',
  267997: 'PREVENTA',
  266819: '2X1',
  268219: 'BOLETIA',
  268213: 'BOLETIA',
  268214: 'BOLETIA',
  267899: 'AMOR',
  267895: 'BOLETIA',
  267894: 'BOLETIA',
  265048: 'BOLETIA',
  265446: 'BOLETIA',
  270751: 'ESPECIAL3X2',
  269855: '3X2',
  269893: '3X2',
  266347: 'JUEVES2X1',
  267414: '2X1',
  268219: 'AMOR',
  268213: 'ANGELES',
  268214: 'ANGELES',
  263871: 'ANGELES',
  263870: 'ANGELES',
  271159: 'PREVENTA',
  267816: '30OFF',
  270878: '15OFF',
  270723: 'PREVENTA',
  270722: 'PREVENTA',
  270721: 'PREVENTA',
  270720: 'PREVENTA',
  268123: '30OFF',
  271154: '2X1',
  268376: '2X1',
  270347: '3X2',
  268136: 'AMOR',
  267943: 'AMOR',
  267993: 'AMOR',
  267946: 'AMOR',
  268137: 'AMOR',
  268012: 'AMOR',
  268212: 'AMOR',
  267902: 'AMOR',
  267904: 'AMOR',
  267901: 'AMOR',
  268013: 'AMOR',
  267900: 'AMOR',
  267898: 'AMOR',
  267897: 'AMOR',
  262491: 'AMOR',
  262292: 'AMOR',
  262494: 'AMOR',
  268135: 'AMOR',
  271114: 'AMOR',
  262492: 'AMOR',
  271319: 'PREVENTA',
  271151: 'AMOR',
  266826: 'INFINITYGOLD',
  266825: 'INFINITYGOLD',
  266824: 'INFINITYGOLD',
  266813: 'INFINITYGOLD',
  267721: '2X1GUATEMALA',
  267947: '2X1CDMX',
  267401: '2X1MTY',
  270776: 'QUEENT',
  267821: '20',
  267812: 'JUEVES20',
  271013: 'JUEVES2X1',
  271338: '3X2',
  271311: '3X2',
  271429: '3X2',
  271336: '3X2',
  271416: '20OFF',
  264306: 'RITUAL',
  272491: 'PREVENTA20',
  272501: '3X2',
  265124: '2X1',
};

export const Templates = {
  PLUS: 1,
  HYBRID: 2,
  HIDDEN_MAP: 3,
};

const blockByToken = {
  264304: '8kx9MQR2snLPBweE5tvb7G',
  266674: '8kx9MQR2snLPBweE5tvb7G',
  266675: '8kx9MQR2snLPBweE5tvb7G',
  266676: '8kx9MQR2snLPBweE5tvb7G',
};

const eventsWithAddOns = [
  222939, 223067, 223069, 250620, 223242, 223246, 223255, 223262, 223273,
  251272, 251375, 251377, 251379, 251380, 245643, 250462, 249553, 243220,
  247206, 223302, 223303, 250252, 248826, 251188, 223307, 251307, 251155,
  251466, 251953,
];

const eventsWithSoldOutMessage = [
  271799, 271909, 271910, 271801, 271804, 271805, 271806, 271809, 271810,
  271811, 271814, 271816, 271818, 271830, 271786, 271813, 271794, 271817,
  271823, 271824, 271825, 271826, 271827, 271828, 271829, 271833, 271821,
  271812, 271834, 271822,
];

const eventsLng = [249553];

const eventsWithBestPlacesDisabled = [263058];

const eventsWithoutCustomization = [
  224058, 234371, 270981, 272553, 272296, 272293, 272647, 272648, 235697,
];

export default function useBoletiaConfig() {
  const billboardsEventCardMobileBackgroundPosition = (billboardId) => {
    const toRight =
      BillboardsEventsMobileBackgroundPositionToRight.includes(billboardId);

    if (toRight) {
      return 'right';
    }

    return BillboardsEventsMobileBackgroundPositionToLeft.includes(billboardId)
      ? 'left'
      : 'center';
  };

  const isBillboardWithShortenTemplate = (billboardId) =>
    billboardsWithShortenTemplates.includes(billboardId);

  const eventUseNewCommision = (eventID, fee_breakdown) =>
    fee_breakdown !== 'f' && EventsWithNewCommissions.includes(eventID);

  const getTemplate = (event, user) => {
    if (user) {
      if (usersTemplateHybrid.includes(user)) {
        return Templates.HYBRID;
      }
      if (usersTemplateHiddenMap.includes(user)) {
        return Templates.HIDDEN_MAP;
      }
    }
    if (event) {
      if (eventsTemplateHybrid.includes(event)) {
        return Templates.HYBRID;
      }
      if (eventsTemplateHiddenMap.includes(event)) {
        return Templates.HIDDEN_MAP;
      }
    }
    return Templates.PLUS;
  };

  const isUserToViewAvailability = (user) =>
    userToViewAvailability.includes(user);

  const isEventToViewAvailability = (user) =>
    eventToViewAvailability.includes(user);

  const eventColorMode = (eventID) =>
    eventsWithDarkMode.includes(eventID) ? 'dark' : 'light';

  const isBillboardDisabledHighlightedEvents = (eventID) =>
    BillboardDisabledHighlightedEvents.includes(eventID);

  const isBillboardsRemoveOpenCard = (billboardId) =>
    BillboardsRemoveOpenCard.includes(billboardId);

  const isBillboardRemoveEventsBanner = (eventID) =>
    BillboardRemoveEventsBanner.includes(eventID);

  const isEventsRemoveNoCustomTicketButton = (eventID) =>
    eventsRemoveNoCustomTicketButton.includes(eventID);
  const isEventsRemoveApplyAllCustomTicketButton = (eventID) =>
    eventsRemoveApplyAllCustomTicketButton.includes(eventID);

  const isBillboardsEventsWithMXN = (eventID) =>
    BillboardsEventsWithMXN.includes(eventID);

  const isEventsSoldOut = (eventID) => eventsSoldOut.includes(eventID);

  const isBillboardWithAllEvents = (billboardId) =>
    BillboardsWithAllEvents.includes(billboardId);

  const isBillboardOdysseySoldOut = (billboardId) =>
    BillboardOdysseySoldOut.includes(billboardId);

  const isBillboardsCardDefaultAction = (billboardId) =>
    BillboardsCardDefaultAction.includes(billboardId);

  const isBillboardsRemoveTags = (billboardId) =>
    BillboardsRemoveTags.includes(billboardId);

  const getPromotionPreLoaded = (eventID) => {
    return promotionPreLoaded[eventID] || null;
  };

  const requiredFanPass = (eventID) => {
    const fanPass = fanPassword[eventID];
    try {
      if (fanPass) {
        if (Array.isArray(fanPass)) {
          const item = fanPass.filter((current) => {
            return isToday(current.start_date, current.end_date);
          });
          return item;
        } else {
          if (isToday(fanPass.start_date, fanPass.end_date)) {
            return fanPass.pass;
          }
        }
      }
    } catch (e) {
      console.log('Error en Fan Pass', e);
    }

    return null;
  };

  const isBlockbyToken = (eventID) => {
    return blockByToken[eventID] || null;
  };

  const isEventsWithAddOns = (eventID) => eventsWithAddOns.includes(eventID);
  const isEventsLng = (eventID) => eventsLng.includes(eventID);

  const isEventWithSaleLabel = (eventId) =>
    eventsWithSaleLabel.includes(eventId);

  const isEventWithBestPlacesDisabled = (eventId) =>
    eventsWithBestPlacesDisabled.includes(eventId);

  const isEventWithSoldOutMessage = (eventId) =>
    eventsWithSoldOutMessage.includes(eventId);

  const isEventWithoutCustomization = (eventId) =>
    eventsWithoutCustomization.includes(eventId);

  return {
    billboardsEventCardMobileBackgroundPosition,
    isBillboardWithShortenTemplate,
    eventUseNewCommision,
    getTemplate,
    isUserToViewAvailability,
    isEventToViewAvailability,
    eventColorMode,
    isBillboardDisabledHighlightedEvents,
    isBillboardsRemoveOpenCard,
    isEventsRemoveNoCustomTicketButton,
    isEventsRemoveApplyAllCustomTicketButton,
    isBillboardWithAllEvents,
    isBillboardsEventsWithMXN,
    isEventsSoldOut,
    isBillboardOdysseySoldOut,
    requiredFanPass,
    isBillboardsCardDefaultAction,
    isBillboardsRemoveTags,
    getPromotionPreLoaded,
    isBlockbyToken,
    isBillboardRemoveEventsBanner,
    isEventsWithAddOns,
    isEventsLng,
    isEventWithSaleLabel,
    isEventWithBestPlacesDisabled,
    isEventWithSoldOutMessage,
    isEventWithoutCustomization,
  };
}
